import React, { useEffect, useState } from "react";
import { useStaticQuery, graphql, Link } from "gatsby";
import PubSub from "pubsub-js";
import clsx from "clsx";
import { _localizeField, _localizeSlug } from "../core/utils";
import Cart from "./shop/Cart";
import LocaleSwitcher from "./ui/LocaleSwitcher";

const query = graphql`
  query {
    # siteBuildMetadata {
    #   buildTime
    # }
    sanityFooter {
      nav {
        label {
          fr
          en
        }
        link {
          ... on SanityCatalog {
            _type
            title
            slug {
              current
            }
          }
          ... on SanityPageModulaire {
            _type
            title
            slug {
              current
            }
          }
        }
      }
    }
  }
`;

const Footer = () => {
  const {
    // siteBuildMetadata: { buildTime },
    sanityFooter: { nav },
  } = useStaticQuery(query);

  const [asideCurrent, setAsideCurrent] = useState();
  const [collapsed, setCollapsed] = useState(true);

  useEffect(() => {
    const tokenA = PubSub.subscribe("ASIDE_CURRENT", (e, d) => {
      setAsideCurrent(d);
    });

    const tokenR = PubSub.subscribe("ROUTE_UPDATE", (e, d) => {
      setCollapsed(true);
    });

    return () => {
      PubSub.unsubscribe(tokenA);
      PubSub.unsubscribe(tokenR);
    };
  }, []);

  const _toggle = () => {
    setCollapsed(!collapsed);
  };

  return (
    <footer
      id='site-footer'
      className={clsx("fL fSeg", collapsed ? "is-collapsed" : "")}>
      <div
        className='sm-only chevron chevron--top'
        onClick={_toggle}
        role='button'>
        <svg
          id='68e9a234-6206-4a17-99cd-df4015e19372'
          xmlns='http://www.w3.org/2000/svg'
          viewBox='0 0 33.88 18.3'>
          <title>ico-chevron--top</title>
          <line x1='15.97' y1='2.09' x2='17.89' y2='2.09' />
          <rect
            x='23.77'
            y='-2.83'
            width='1.92'
            height='23.96'
            transform='translate(0.77 20.17) rotate(-45)'
          />
          <rect
            x='-2.83'
            y='8.19'
            width='23.96'
            height='1.92'
            transform='translate(-3.79 9.15) rotate(-45)'
          />
        </svg>
      </div>
      <nav className='menu-footer'>
        <ul className='x xjb'>
          {asideCurrent && (
            <li
              className='menu-item sm-only curp'
              // role='button'
              // onClick={_toggle}
            >
              {asideCurrent}
            </li>
          )}
          <li className='menu-item'>
            <Cart />
          </li>
          {nav.map((li, i) => (
            <li key={i} className='menu-item'>
              <Link to={_localizeSlug(li.link)}>
                {_localizeField(li.label)}
              </Link>
            </li>
          ))}
          {/* <li className='hidden-sm'>
            <LocaleSwitcher />
          </li> */}
        </ul>
      </nav>
    </footer>
  );
};
export default Footer;
